<template>
  <div class="grid loader">
    <div class="col text-center loader-content">
      <lottie-player
        ref="loaderLottieRef"
        :src="LoaderSpm"
        speed="1"
        direction="1"
        mode="normal"
        loop
        autoplay
        style="width: 200px; height: 200px;"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onBeforeUnmount } from 'vue';
import LoaderSpm from '@/assets/lottie/Loader.json';
// eslint-disable-next-line import/extensions
import '@/assets/js/lottie-player.js';

export default defineComponent({
  name: 'Loader',

  setup() {
    const loaderLottieRef = ref();

    onBeforeUnmount(() => {
      if (loaderLottieRef.value) {
        loaderLottieRef.value.destroy();
      }
    });

    return {
      LoaderSpm,
      loaderLottieRef,
    };
  },

});
</script>

<style scoped lang="scss">
.loader {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  margin: 0;
  width: 100%;
  height: 100%;
  background: $loaderBackgroundColor;
  opacity: 0.8;
  z-index:1102;
}

.loader-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
